import React, { FC } from 'react';

import { SpinnerWrapper, SpinnerItem, Container } from './styles';

export const Loader: FC<{ isWithMargins?: boolean }> = ({ isWithMargins = true }) => (
  <Container isWithMargins={isWithMargins}>
    <SpinnerWrapper>
      <SpinnerItem />
      <SpinnerItem />
      <SpinnerItem />
    </SpinnerWrapper>
  </Container>
);
